export default {
  general_permissions_tab_subtitle:
    'This section covers general system permissions for this user in this program',
  duet_permissions_tab_subtitle:
    'This section outlines permissions related to Duet',
  snapshot_permissions_tab_subtitle:
    'This section outlines permissions related to Snapshot',
  casper_permissions_tab_subtitle:
    'This section outlines permissions related to Casper',
  analytics_permissions_tab_subtitle:
    'These are the types of content the user can view within Analytics',
  permissions_tab_data_types: 'Data types',
  permissions_tab_data_filters: 'Data filters',
  permissions_tab_data_filters_subtitle:
    'This section outlines which specific subsets of data a user can access',
  permissions_tab_data_filters_no_access: 'No access',
  permissions_tab_data_filters_no_access_description:
    'This user cannot see any records. Any dashboard to which this user has been granted access (via data types) will not be populated with any records at this time. Data access must be defined to allow this user to view records.',
  permissions_tab_data_filters_unrestricted_access: 'Unrestricted access',
  permissions_tab_data_filters_unrestricted_access_description:
    'This user can see all records. Any dashboard that this user has access to (via data types) will be fully populated with all available records. Any new incoming records will automatically be made accessible for this user.',
  analytics_help_text: 'Need Help? Learn more about data types and filters',
  save_general_permissions: 'Save general permissions',
  save_duet_permissions: 'Save Duet permissions',
  save_snapshot_permissions: 'Save Snapshot permissions',
  save_casper_permissions: 'Save Casper permissions',
  save_analytics_permissions: 'Save Analytics permissions',
  general_permissions_title: 'General permissions',
  duet_permissions_title: 'Duet permissions',
  snapshot_permissions_title: 'Snapshot permissions',
  casper_permissions_title: 'Casper permissions',
  analytics_permissions_title: 'Analytics permissions',
  feature_category_title: 'Features',
  data_category_title: 'Data types',
  data_category_subtitle_analytics:
    'These are the types of content the user can view within Analytics.',
  navigation_confirmation_title: 'You have unsaved changes',
  navigation_confirmation_description_line_1:
    'If you navigate away or switch tabs now, your changes will be lost.',
  navigation_confirmation_description_line_2:
    'Do you want to stay and continue editing, or leave without saving?',
  navigation_confirmation_stay: 'Stay',
  navigation_confirmation_leave_without_saving: 'Leave without saving',
  save_permissions_duration:
    'Permission updates may take up to 15 minutes to be reflected across the system.',
  save_permissions_success_toast_message: 'Your changes have been saved.',
  save_permissions_error_toast_message:
    'Something went wrong. Your changes could not be saved. Please try again.',
  no_program_permissions:
    'This user does not have any permissions assigned to this program. Assign permissions to ensure the user can access this program.',
  program_permissions: 'Program permissions',
  unrestricted_access_summary:
    '<b>{{name}}</b> has full access to records belonging to the <b>data type permissions</b> granted above. This user can see records for their authorized data types for:',
  unrestricted_access_summary_description:
    'All <b>Learners</b><br />AND<br />All <b>Learning events</b>',
  data_filter_description:
    'The following filters are used to define granular data access for <b>{{name}}</b>. As filter options are selected, the data filter summary to the left will reflect how these filters work together. To grant this user unrestricted access, uncheck the below options.',
  filter_data_by_learner: "Filter data access by 'Learner' attributes",
  filter_data_by_learning_events:
    "Filter data access by 'Learning event' attributes",
  manage_data_filters: 'Manage filters',
  restricted_access_summary:
    '<b>{{name}}</b> has no access to records belonging to the <b>data type permissions</b> granted above. This user can see <b>no</b> data records. Remove or select filters on the right to give full or limited access.',
  limited_access_summary:
    '<b>{{name}}</b> has limited access to records belonging to the <b>data type permissions</b> granted above. This user can only see records for their authorized data types where:',
  filter_access_warning:
    'Enabling Data filters and NOT selecting learners NOR learning events will prevent user from accessing to ANY data.',
  filter_access_alert:
    'Upon saving Analytics permissions, this data filter section will be turned off because there are no current filter selections.',
  confirm_uncheck_filter_title: 'Please confirm',
  confirm_uncheck_filter_body:
    "Are you sure you want to uncheck this section? Doing so will clear all '{{filterType}}' attributes.",
  filter_type_learner: 'Learner',
  filter_type_learning_event: 'Learning event',
  create_new_user: 'Create new user',
  create_new_admin: 'Create new administrator',
  create_admin_account: 'Create administrator account',
  create_user_account: 'Create user account',
  add_to_program: 'Add to program(s)',
  add_program_access: 'Add program access',
  add_program_access_description:
    'Adding a program will allow this user to access program-specific products and data. After adding the program(s), you’ll need to assign specific permissions to ensure they have the appropriate access.',
  add_program_access_success: '{{name}} successfully added to {{programs}}',
  add_program_access_error:
    'Failed to add {{name}} to {{programs}}. Please try again or contact support if the issue persists.',
  remove_program_access: 'Remove program access',
  remove_program_access_description:
    "Are you sure you want to remove {{name}}'s access to {{program}}? This action will remove all associated permissions for this program, and the user will no longer be able to access any related content.",
  remove_access: 'Remove access',
  remove_program_access_success:
    '{{name}} access to {{program}} has been successfully removed.',
  remove_program_access_error:
    'Something went wrong. Unable to remove access. Please try again.',
  no_programs_assigned:
    'No programs assigned. Add this user to a program to manage their permissions.',
  impersonation_error: 'Impersonation Failed!',
  create_admin_alert_description:
    "This will create an administrator user with access to ALL PROGRAMS and special tooling reserved for Acuity Insights employees. This user type is to be used exclusively for Acuity Insights staff! Administrator accounts must have an email address ending in the 'acuityinsights.com' domain to log in successfully.",
  create_admin_success: 'Administrator account created successfully.',
  create_user_success: 'User account created successfully.',
  create_analytics_account_prompt:
    "This user will be using the 'Analytics' product in one or more of the selected programs.",
  no_users_selected_tooltip: 'Please select at least one user to export.',
  removing_archived: 'Removing "archived" role will activate this account.',
  adding_archived: 'Adding "archived" role will deactivate this account.',
  confirm: 'Are you sure you want to continue?',
  user_roles_admin: 'admin',
  user_roles_school_admin: 'school-admin',
  user_roles_team_member: 'team-member',
  user_roles_archived: 'archived',
  user_roles_rater: 'rater',
  user_roles_reviewer: 'reviewer',
  user_roles_formative: 'formative',
  last_invite_sent: 'Last invite sent',
  successful: 'successful',
  failed: 'failed'
};
